import axios from 'axios'

export default {
    getNewComer(){
        return axios.get('/newcomer')
            .then(response => {
                return response.data
            })
    },
    getNewComerDataSource(params){
        return axios.get('/newcomer/datasource', {params})
            .then(response => {
                return response.data
            })
    },
    getNewComerbyID(id){
        return axios.get('/newcomer/' + id)
            .then(response => {
                return response.data
            })
    },    
    createNewComer(formdata){
        return axios.post('/newcomer', formdata)
            .then(response => {
                return response.data
            })
    },
    updateNewComer(id,formdata){
        return axios.put('/newcomer/' + id, formdata)
            .then(response => {
                return response.data
            })
    },
    converttomember(id){
        return axios.post('/newcomer/'+id+'/convert')
            .then(response => {
                return response.data
            })
    },    
    assign_icare(id, formdata){
        return axios.post('/newcomer/'+id+'/assign_icare', formdata)
            .then(response => {
                return response.data
            })
    }, 
}